import React from 'react';
import $ from 'jquery';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';

import leftArrow from '../../../svg/gray-arrow-left.svg';
import rightArrow from '../../../svg/gray-arrow-right.svg';
import './instagram-slideshow.scss';

interface Props {
  close: Function;
  id: string;
  images: any[];
  selectedImage: String;
}

class AttendeeList extends React.Component<Props> {
  componentDidMount() {
    $(`#${this.props.id}`).modal('show');
    $(`#${this.props.id}`).on('hidden.bs.modal', (e) => this.props.close());
  }

  buildImages() {
    const splideImages: JSX.Element[] = [];

    this.props.images.forEach((element) => {
      splideImages.push(
        <div className="each-slide" key={element.id}>
          <img src={element.media_url} />
        </div>
      );
    });

    return splideImages;
  }

  render() {
    return (
      <div className="modal fade instagram-modal" id={this.props.id} role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <Slide
              {...{
                defaultIndex: this.props.images.findIndex(
                  (element) => element.id === this.props.selectedImage
                ),
                transitionDuration: 200,
                autoplay: false,
                indicators: true,
                prevArrow: (
                  <div className="prev">
                    <img src={leftArrow} />
                  </div>
                ),
                nextArrow: (
                  <div className="next">
                    <img src={rightArrow} />
                  </div>
                ),
              }}
            >
              {this.buildImages()}
            </Slide>
          </div>
        </div>
      </div>
    );
  }
}

export default AttendeeList;
